import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name list-start
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA1aDYiIC8+CiAgPHBhdGggZD0iTTMgMTJoMTMiIC8+CiAgPHBhdGggZD0iTTMgMTloMTMiIC8+CiAgPHBhdGggZD0ibTE2IDgtMy0zIDMtMyIgLz4KICA8cGF0aCBkPSJNMjEgMTlWN2EyIDIgMCAwIDAtMi0yaC02IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/list-start
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ListStart: IconNode = [
  ['path', { d: 'M3 5h6' }],
  ['path', { d: 'M3 12h13' }],
  ['path', { d: 'M3 19h13' }],
  ['path', { d: 'm16 8-3-3 3-3' }],
  ['path', { d: 'M21 19V7a2 2 0 0 0-2-2h-6' }],
];

export default ListStart;
